import Button from 'shared/components/Button'

import styles from '../styles.module.scss'

const SubscriptionLiteForm = () => (
    <>
        <T>subscription.lite.confirmation</T>
        <Button
            className={`mt-3 ${styles.proceedButton}`}
            size="large"
            external
            href="https://parkindigo.ca/en/customer-space/monthly-parking/">
            <T>subscription.lite.proceed</T>
        </Button>
    </>
)

export default SubscriptionLiteForm
